import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Tooltip
} from 'reactstrap';

import { Separator } from '../../../../../../components/common/CustomBootstrap';

let arr = [];
export default function IntegrationInfo({
  integration,
  integrationProperties,
  allProperties,
  saveIntegration,
}) {
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [collectionName, setCollectionName] = useState('');
  const [description, setDescription] = useState('');
  const [propertyList, setPropertyList] = useState([]);

  useEffect(() => {
    const result = integrationProperties.map(id => {
      return allProperties.find(elem => elem.id === id);
    });
    setFormatedProperties(result);
    setList(integrationProperties);
    if (integration.name !== undefined && integration.name !== null) {
      setName(integration.name);
    }
    const property = allProperties?.map((elem) => {
      elem.checked = false;
      result.forEach((lang) => {
        if (lang.id === elem.id) {
          elem.checked = true;
        }
      });
      return elem;
    });
    setPropertyList(property);
    if (integration !== undefined && integration.restapiIntegration !== undefined) {
      setCollectionName(integration.restapiIntegration?.collectionName);
      setDescription(integration.restapiIntegration?.description);
    }

  }, [integrationProperties, allProperties]);

  const handleCheckChange = (e) => {
    const values = propertyList.map((elem) => {
      if (elem.id === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setPropertyList(values);
    const propertyArr = values.filter((elem) => elem.checked === true).map((elem) => elem.id);
    setList(propertyArr);
  };

  const handleSave = () => {
    saveIntegration({ list, name, collectionName, description });
    arr = [];
    setList([]);
    setIsEditing(!isEditing);
  };

  const handleNameChange = e => {
    setName(e.target.value);
  };

  const handleCollectonName = e => {
    setCollectionName(e.target.value);
  };

  const handleDescription = e => {
    setDescription(e.target.value);
  };
  const allSelected =
    propertyList.length > 0 &&
    propertyList.every((p) => p.checked === true);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;

    const updatedList = propertyList.map((elem) => ({
      ...elem,
      checked: checked,
    }));

    setPropertyList(updatedList);

    const propertyArr = checked
      ? updatedList.map((elem) => elem.id)
      : [];

    setList(propertyArr);
  };

  const Show = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
            Select Business
          </h6>
        </div>
        <Separator className="mb-3" />
        <div className="text-left">
          <h1 className='mb-3'>{integration ? integration.name : null}</h1>

          <div className='mb-3'>
            <h4>Collection Name</h4>
            <div className="mb-2">
              <span className="text-muted">
                {collectionName}
              </span>
            </div>
          </div>

          <div className='mb-3'>
            <h4>Description</h4>
            <div className="mb-2">
              <span className="text-muted">
                {description}
              </span>
            </div>
          </div>

          <div className='mb-3'>
            <h4>Group ID</h4>
            <div className="mb-2">
              <span className="text-muted">
                {integration ? integration.groupId : null}
              </span>
            </div>
          </div>
          <div>
            <h4>Business</h4>
            <div className="mb-2">
              {formatedProperties
                ? formatedProperties.map((elem, index) => {
                  return (
                    <div key={index} className="mb-2">
                      <b>{elem ? elem?.name : null}</b>{' '}
                      <span className="text-muted">
                        ({elem ? elem.id : null})
                      </span>
                    </div>
                  );
                })
                : null}
            </div>
          </div>
        </div>
        <div className="text-center">
          <Button
            size="xs"
            color="success"
            outline
            style={{ marginTop: '20px', display: 'inline-block' }}
            onClick={() => setIsEditing(!isEditing)}
          >
            Edit
          </Button>
        </div>
      </CardBody>
    );
  };

  const Edit = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
            Integration Information{' '}
            {/* <Tooltip
              item={{
                text: '?',
                body:
                  'Integration allows you to select the chat widget appearance, choose properties, and generate code to publish your digital assistant on your website.',
              }}
              id={integration.id}
            /> */}
          </h6>
        </div>
        <div className="text-left">
          <Separator className="mb-3" />
          <div className="mb-3">
            <h6 className=''>Integration Title</h6>
            <Input
              className="form-control"
              name="name"
              defaultValue={integration.name}
              onChange={handleNameChange}
            />
          </div>
          <div className="mb-3">
            <h6 className=''>Collection Name</h6>
            <Input
              className="form-control"
              name="name"
              placeholder="Collection Name"
              defaultValue={collectionName}
              onChange={handleCollectonName}
            />
          </div>
          <div className="mb-3">
            <h6 className=''>Description</h6>
            <Input
              className="form-control"
              name="description"
              placeholder="Description"
              defaultValue={description}
              onChange={handleDescription}
            />
          </div>
          <div className='mb-3'>
            <h6>Group ID</h6>
            <div className="mb-2">
              <span className="text-muted">
                {integration ? integration.groupId : null}
              </span>
            </div>
          </div>
          <div>
            <Form>

              <h6>Businesses</h6>
              <FormGroup>
                <div className='integration-property'>
                  <CustomInput
                    type="checkbox"
                    id="select-all"
                    label="Select All"
                    checked={allSelected}
                    onChange={handleSelectAll}
                  />

                  {propertyList.map((p, index) => {
                    return (
                      <CustomInput
                        key={p.id}
                        type="checkbox"
                        id={index}
                        checked={p.checked}
                        label={p.name}
                        value={p.id}
                        onChange={handleCheckChange}
                      />
                    );
                  })}
                </div>
              </FormGroup>
            </Form>
          </div>
        </div>
        <Separator className="my-2"></Separator>
        <div className='text-center'>
          <div className="mb-2" style={{ marginTop: '20px' }}>
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button
              size="xs"
              color="secondary"
              className='ml-2'
              onClick={() => setIsEditing(!isEditing)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </CardBody >
    );
  };

  return <Card className="mb-4">{isEditing ? Edit() : Show()}</Card>;
}
